import Basemap from '@arcgis/core/Basemap';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import TileLayer from '@arcgis/core/layers/TileLayer';

import { Environment } from '../../../../environments/environment';

export const TVBasemap = new Basemap({
  baseLayers: [
    new TileLayer({
      effect: 'brightness(100%) saturate(100%) contrast(100%) opacity(100%)',
      url: Environment.mapServer,
    }),
  ],
  referenceLayers: [
    new MapImageLayer({
      url: `${Environment.mapServer}/2509`,
    }),
  ],
  title: Environment.community === 'villages' ? 'The Villages' : 'Middleton',
});
